<template>
  <div class="fill-width">
    <div v-if="!!label" class="text-body-2 mb-1">{{ label }}</div>
    <v-text-field
      solo
      flat
      v-model="value"
      :outlined="outlined"
      v-mask="mask"
      v-on="$listeners"
      class="rounded-lg"
      :style="uppercase ? { textTransform: 'uppercase' } : {}"
      background-color="var(--dk-wash, #F1F3F5)"
      :append-icon="appendIcon"
      :placeholder="placeholder"
      :rules="required ? rules : []"
      :readonly="readonly"
      :disabled="disabled"
      :type="type"
      :hide-details="hideDetails ? 'auto' : false"
      :hint="hint"
      :error-messages="errorMessage"
      @click:append="handleAppendIconClick"
    />
  </div>
</template>
<script>
import { VueMaskDirective } from "v-mask";
export default {
  name: "custom-input",
  directives: {
    mask: VueMaskDirective,
  },
  data() {
    return {
      value: "",
    };
  },
  props: {
    currentValue: {
      type: [String, Number],
      default: null,
    },

    label: {
      type: String,
      default: "",
    },

    placeholder: {
      type: String,
      default: "",
    },

    appendIcon: {
      type: String,
      default: "",
    },

    type: {
      type: String,
      default: "text",
    },

    customRule: {
      type: Array,
      default: () => [],
    },

    required: {
      type: Boolean,
      default: true,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    hideDetails: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: "",
    },
    errorMessage: {
      type: String,
      default: "",
    },
    mask: {
      type: String,
      default: "'##/##/#### ##:##'",
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    uppercase: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    if (this.currentValue) this.value = this.currentValue;
  },

  computed: {
    rules() {
      return this.customRule.length <= 0
        ? [(v) => !!v || this.$t("common.requiredField")]
        : this.customRule;
    },
  },

  methods: {
    handleInput(event) {
      this.value = event;
      this.$emit("input", event);
    },
    handleAppendIconClick() {
      this.$emit("iconClick");
    },
  },
};
</script>
<style scoped></style>
